"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepMerge_1 = require("../utils/deepMerge");
var ThemeDefaults_1 = __importStar(require("./ThemeDefaults"));
var defaults = deepMerge_1.deepMerge(ThemeDefaults_1.default, {
    palette: {
        type: 'dark',
        primary: {
            main: '#499fe6',
            dark: '#004884',
        },
        secondary: {
            main: '#de2525',
            dark: '#d85151',
        },
        background: {
            default: '#303030',
        },
    },
    overrides: {
        MuiTextField: {},
        MuiFilledInput: {
            root: {
                backgroundColor: ThemeDefaults_1.grey[700],
                '&:hover': {
                    backgroundColor: ThemeDefaults_1.grey[800],
                },
                '&.Mui-focused': {
                    backgroundColor: ThemeDefaults_1.grey[800],
                },
            },
        },
    },
});
exports.default = defaults;
//# sourceMappingURL=DarkThemeDefaults.js.map